/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmailSettingsStatusResponse } from '../../models/email-settings-status-response';

export interface GetEmailSettingsStatus$Params {
  tenantId: string;
  'Active-Tenant-Identifier': string;
}

export function getEmailSettingsStatus(http: HttpClient, rootUrl: string, params: GetEmailSettingsStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<EmailSettingsStatusResponse>> {
  const rb = new RequestBuilder(rootUrl, getEmailSettingsStatus.PATH, 'get');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmailSettingsStatusResponse>;
    })
  );
}

getEmailSettingsStatus.PATH = '/tenants/{tenantId}/email-settings/status';
